import { Typography, Container } from '@mui/material';

const TypesDocuments = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
                Types de documents
            </Typography>
            <Typography>
                Catalogue des types de documents. Ajoutez ici la logique pour gérer les types.
            </Typography>
        </Container>
    );
};

export default TypesDocuments;